/*
 * Pairing rules for the Professionally Framed line.
 * __related_variant is the print's __custom_id, not a Shopify variant id.
 * Loaded by the product form. Not published until the theme is published.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  root.AndyFramingService = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  function itemProps(item) {
    return (item && item.properties) || {};
  }

  function isServiceLine(item) {
    return !!(item && item.sku && String(item.sku).indexOf("INRAMNING") === 0);
  }

  function isFrameLine(item) {
    return !!(item && item.sku && String(item.sku).indexOf("ANDY-FRAME-") === 0);
  }

  /**
   * Add a framing-service line only when a print in the cart already carries
   * this token, and no service line is already tied to it.
   */
  function shouldAddFramingService(cartItems, token) {
    if (!token) return false;
    var items = Array.isArray(cartItems) ? cartItems : [];
    var parent = null;
    var already = false;
    for (var i = 0; i < items.length; i++) {
      var props = itemProps(items[i]);
      if (props.__custom_id === token) parent = items[i];
      if (isServiceLine(items[i]) && props.__related_variant === token) already = true;
    }
    return !!(parent && !already);
  }

  /**
   * A print claims a frame when __frame or __custom_id is set.
   * The frame is present only when another line shares that token and is a frame SKU.
   * A service fulfilment group that does not contain the frame is not, by itself, a missing frame.
   */
  function classifyLines(lines) {
    var items = Array.isArray(lines) ? lines : [];
    var missingFrame = [];
    var orphanService = [];
    var paired = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var props = itemProps(item);
      if (props.__custom_id && (props.__frame || props.__framing_service)) {
        var frame = null;
        for (var j = 0; j < items.length; j++) {
          if (isFrameLine(items[j]) && itemProps(items[j]).__related_variant === props.__custom_id) {
            frame = items[j];
          }
        }
        if (!frame) missingFrame.push(item.sku || "");
        else paired.push(item.sku || "");
      }
      if (isServiceLine(item)) {
        var rel = props.__related_variant;
        var print = null;
        for (var k = 0; k < items.length; k++) {
          if (itemProps(items[k]).__custom_id === rel) print = items[k];
        }
        if (!rel || !print) orphanService.push(item.sku || "");
      }
    }
    return { missingFrame: missingFrame, orphanService: orphanService, paired: paired };
  }

  return {
    shouldAddFramingService: shouldAddFramingService,
    classifyLines: classifyLines,
  };
});
